import { useState } from 'react';

import { useBbrLookup } from '~src/hooks/graphql/useBbrLookup';
import { useFetchHeatPumpOutdoorUnits } from '~src/hooks/graphql/useHeatPump';
import { useOverrideAddressByID } from '~src/hooks/useDAWA/useOverrideAddressByID';
import { useOfferTypeSavings } from '~src/hooks/useOfferTypeSavings';
import { ProductTypes, Residence } from '~src/model';

import { useAvailableProductTypes } from './useAvailableProductTypes';

export const useEstimatePageResidenceAndProducts = (allowedProductTypes?: ProductTypes) => {
  const [residence, setResidence] = useState<Partial<Residence>>();
  const [hasBbrData, setHasBbrData] = useState<boolean>();

  const { address } = useOverrideAddressByID();

  const { data: outdoorUnits = [] } = useFetchHeatPumpOutdoorUnits() ?? {};

  const { selectedProductTypes, setSelectedProductTypes, heatPumpTakeover, solarTakeover } = useAvailableProductTypes(
    residence,
    outdoorUnits,
    allowedProductTypes
  );

  const { products } = useOfferTypeSavings(selectedProductTypes) ?? {};

  const { isFetching: isFetchingBbrData } = useBbrLookup(address, setResidence, setSelectedProductTypes, setHasBbrData);

  return {
    residence,
    address,
    selectedProductTypes,
    setSelectedProductTypes,
    heatPumpTakeover,
    solarTakeover,
    products,
    hasBbrData,
    isFetchingBbrData,
  };
};
